import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { SyncHistoriesGetResponse } from "@/types/swagger";
import API from "@/api";

export interface IHistoryState {
  sync_histories_id: number; //同期履歴ID
  sync_target_group_id: number; //同期対象グループID
  sync_start_date_time: string; //同期開始日時（yyyyMMddHHmmssSSS）
  company_id: number; //会社ID
  company_name: string; //会社名
  status: 0 | 1 | 9; //ステータス0:同期中 1:同期終了9:エラー
  sync_target_num: number; //同期人数
  message: string; //メッセージ
  sync_histories_details: IHistoryDetail[]; // 同期履歴詳細一覧
}

export interface IHistoryDetail {
  sync_histories_details_id: number; //同期履歴詳細ID
  sync_start_date_time: string; //同期開始日時（yyyyMMddHHmmssSSS）
  company_id: number; //会社ID
  company_name: string; //会社名
  status: 0 | 1 | 9; //ステータス0:同期中 1:同期終了9:エラー
  sync_target_num: number; //同期人数
  message: string; //メッセージ
}

const initialState: IHistoryState[] = [];

@Module({
  name: "Histories",
  stateFactory: true,
  namespaced: true,
})
export class Histories extends VuexModule {
  private histories: IHistoryState[] = initialState;
  private stateLastUpdatedDate: Date | null = null;

  public get getStateLastUpdatedDate() {
    return this.stateLastUpdatedDate;
  }

  @Mutation setStateLastUpdatedDate(date: Date) {
    this.stateLastUpdatedDate = date;
  }

  public get getHistories() {
    return this.histories;
  }

  @Mutation set(histories: IHistoryState[]) {
    this.histories = histories;
  }

  @Action({ rawError: true })
  public init() {
    this.set(initialState);
  }

  @Action({ rawError: true })
  public async fetchHistories(userId: number) {
    const api = new API();
    const response: SyncHistoriesGetResponse = await api.get(
      `/users/${userId}/sync/histories`,
      {}
    );
    if (Array.isArray(response.sync_histories)) {
      const histories: IHistoryState[] = [];
      response.sync_histories.forEach((history: any) => {
        if (
          history.sync_histories_id &&
          history.sync_target_group_id &&
          history.sync_start_date_time &&
          Array.isArray(history.sync_histories_details)
        ) {
          let isNotValidatedHistoryDetail = false;
          history.sync_histories_details.forEach((detail: any) => {
            if (
              !detail.sync_histories_details_id ||
              !detail.sync_start_date_time ||
              !detail.company_name
            ) {
              isNotValidatedHistoryDetail = true;
            }
          });
          if (!isNotValidatedHistoryDetail) {
            const his: any = {};
            for (const [key, value] of Object.entries(history)) {
              his[key] = value;
            }
            histories.push(his);
          }
        }
      });
      this.set(histories);
      this.setStateLastUpdatedDate(new Date());
    }
  }
}
